export const oldLines = {

	"title": "POSITANO COUTURE",
	"subtitle": "COLLECTION",
	"descriptionITA": "Questa collezione conta sulla giusta dose di eleganza con note di bellissimi pizzi e ricami italiani",
    "descriptionENG": "This collection count on the right amount of elegance with notes of beautiful italian laces and embroidery"


};


export const oldLinesProducts = [
    {
        "photo": "lookbook2/1_oldLines/5.jpg",
        "retro": "",
        "photomin": "lookbook2/1_oldLines/5-min.jpg",
        "retromin": "",

        "prod1": "ABITO FORMENTERA",
        "stile1": "Uniti Lino | Cartella Colori",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook2/1_oldLines/12.jpg",
        "retro": "",
        "photomin": "lookbook2/1_oldLines/12-min.jpg",
        "retromin": "",
        "prod1": "ABITO ST JOSE'",
        "stile1": "Uniti lino | Ricamo | Cartella Colori",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook2/1_oldLines/cassandra.jpg",
        "retro": "",
        "photomin": "lookbook2/1_oldLines/cassandra-min.jpg",
        "retromin": "",
        "prod1": "ABITO CASSANDRA",
        "stile1": "Ricamo | Ricamo Mini | Cartella Colori",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook2/1_oldLines/delizia.jpg",
        "retro": "",
        "photomin": "lookbook2/1_oldLines/delizia-min.jpg",
        "retromin": "",
        "prod1": "ABITO DELIZIA",
        "stile1": "Ricamo | Cartella Colori",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook2/1_oldLines/fenice1.jpg",
        "retro": "",
        "photomin": "lookbook2/1_oldLines/fenice1-min.jpg",
        "retromin": "",
        "prod1": "ABITO FENICE",
        "stile1": "Uniti Lino | Cartella Colori | Ricamo Mini",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook2/1_oldLines/formentea2.jpg",
        "retro": "",
        "photomin": "lookbook2/1_oldLines/formentea2-min.jpg",
        "retromin": "",
        "prod1": "ABITO IBIZA",
        "stile1": "Unito | Cartella Colori",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook2/1_oldLines/ieranto2.jpg",
        "retro": "",
        "photomin": "lookbook2/1_oldLines/ieranto2-min.jpg",
        "retromin": "",
        "prod1": "ABITO IERANTO",
        "stile1": "Cartella colori",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    }
];
